<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="page-header-toolbar">
      <h2 class="page-title">{{ $t("checklist.properties") }}</h2>
    </v-app-bar>

    <data-list :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>

    <v-dialog v-model="propDialog" fullscreen hide-overlay transition="dialog-bottom-transition" persistent class="checklist-component">
      <v-progress-linear :active="loading" :indeterminate="loading" color="primary"></v-progress-linear>
      <property
        @update="onSuccessHandler"
        :properties="properties"
        :payload="payload"
        @selected="getSelected"
        v-if="propDialog"
        @closeForm="closeDialogHandler"
      ></property>
    </v-dialog>
  </v-container>
</template>
<script>
import VueCookie from "vue-cookie"
import DataList from "@/mixins/components/DataList.vue"
import { checklistApi } from "@/plugins/api_settings"
import { listOfFormTypes } from "@/utils/support_list"
export default {
  data() {
    return {
      total: 0,
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: false,
        headers: [],
        list: [],
        loading: false,
        editProp: "name",
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler
      },
      listOfTypes: listOfFormTypes.sort((a, b) => a.text.localeCompare(b.text)),
      loading: false,
      propDialog: false,
      pagination: {
        sortBy: ["name"],
        itemsPerPage: 25,
        sortDesc: [false],
        search: ""
      },
      payload: {
        from: "properties",
        propid: 0
      },
      properties: { _id: null, is_active: true, favourite: false, font_size: 1 }
    }
  },
  components: {
    DataList,
    property: () => import("@/mixins/components/checklist/property/Index.vue")
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("checklistapi.customer.name"),
          value: "name",
          isRoute: true,
          isModal: true,
          dbRef: "Name",
          width: "30%"
        },
        {
          text: this.$t("checklistapi.checklist.label"),
          value: "label",
          sortable: true,
          dbRef: "Label",
          width: "20%"
        },
        {
          text: this.$t("checklistapi.products.type"),
          value: "type",
          sortable: false,
          dbRef: "Type",
          width: "20%"
        },
        {
          text: this.$t("checklistapi.checklist.placeholder"),
          value: "placeholder",
          sortable: true,
          dbRef: "Placeholder",
          width: "20%"
        },
        {
          text: this.$t("checklistapi.common.isActive"),
          value: "is_active",
          dbRef: "Is_Active",
          isBoolean: true,
          sortable: false,
          width: "20%"
        }
      ]
    }
  },
  watch: {
    pagination: {
      handler(val) {
        this.getListHandler()
      },
      deep: true
    }
  },
  created() {
  },
  mounted() {
    this.$eventBus.$on("deleteItems", (data) => {
      if (data.module === "properties") {
        const modelObj = { data: { ids: data.ids } }

        this.$awn.confirm(
          this.$t("global.delete_message"),
          () => {
            return
          },
          () => {
            checklistApi
              .delete("properties/delete_multiple", modelObj)
              .then((response) => {
                this.listPayloadObj.selection = []
                this.$awn.success(
                  this.$t("global.delete_success", {
                    module: this.$t("checklist.properties")
                  })
                )
                this.getListHandler()
              })
              .finally(() => {})
          },
          {
            labels: {
              confirm: "",
              confirmCancel: this.$t("global.yes"),
              confirmOk: this.$t("global.no")
            }
          }
        )
      }
    })
  },
  methods: {
    getListHandler() {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = "properties"
      const queryFields = this.$format.cloneVariable(this.headers)
      queryFields.pop()
      let { page, sortBy, sortDesc, search, itemsPerPage } = this.$format.cloneVariable(this.pagination)
      const result = queryFields.find((x) => x.value === sortBy[0])
      if (result) sortBy = result.dbRef
      sortDesc = sortDesc[0]
      const pageVal = page || 1
      const query = [
        {
          $match: {
            $or: [
              { Name: { $regex: `${search}`, $options: "i" } },
              { Label: { $regex: `${search}`, $options: "i" } },
              { Type: { $regex: `${search}`, $options: "i" } },
              { Placeholder: { $regex: `${search}`, $options: "i" } },
              { Is_Active: { $regex: `${search}`, $options: "i" } }
            ]
          }
        },
        { $skip: (pageVal - 1) * itemsPerPage },
        { $limit: itemsPerPage },
        { $sort: { [sortBy]: sortDesc ? -1 : 1 } }
      ]
      if (!search) query.splice(0, 1)
      checklistApi
        .post("properties/query", query)
        .then((response) => {
          const countQuery = [{ $count: "count" }]
          this.listPayloadObj.list = []
          if (response.data.length > 0) {
            if (search) {
              countQuery.splice(0, 0, {
                $match: {
                  $or: [
                    { Name: { $regex: `${search}`, $options: "i" } },
                    { Label: { $regex: `${search}`, $options: "i" } },
                    { Type: { $regex: `${search}`, $options: "i" } },
                    { Placeholder: { $regex: `${search}`, $options: "i" } },
                    { Is_Active: { $regex: `${search}`, $options: "i" } }
                  ]
                }
              })
            }
            checklistApi.post("properties/query", countQuery, this.apiHeaders).then((response) => {
              this.total = response.data.length > 0 ? response.data[0].count : 0
            })
            const data = response.data
            data.forEach((element) => {
              element.id = element._id
              const result = this.listOfTypes.find((x) => x.value === element.type)
              element.type_id = element.type
              element.type = result ? result.text : ""
            })
            this.listPayloadObj.list = data
          }
        })
        .finally(() => {
          this.listPayloadObj.loading = false
        })
    },
    onSuccessHandler(payload) {
      if (payload.status === "success") {
        let text = ""
        if (payload.data) {
          if (payload.action === "update") text = "Updated Successfully!"
          else if (payload.action === "add") text = "Added Successfully!"
          this.$awn.success(text)
        }
        if (payload.type === "UPDATE_CLOSE") this.closeDialogHandler()
        else this.properties._id = payload.data.data._id
        this.getListHandler()
      } else if (payload.status === "error") {
        this.$awn.alert(payload.data.response.data)
      }
    },
    openDialogHandler() {
      this.propDialog = true
    },
    closeDialogHandler() {
      this.propDialog = false
      this.payload = { from: "properties", propid: 0 }
      this.properties = { _id: null, is_active: true }
    },
    getSelected(model) {
      this.properties = model
    },
    getSingleRecordHandler(id) {
      this.properties._id = id
      this.propDialog = true
    },
    beforeDestroy() {
      this.$eventBus.$off("deleteItems")
    }
  }
}
</script>
